<form [formGroup]="addressForm">
  <div class="p-grid">
    <div class="p-col-12 p-md-3 p-mt-2 p-mt-lg-0">
      <p-dropdown
        optionLabel="name"
        optionValue="value"
        [ngClass]="{
          invalid:
            isRequired && isSubmited && !addressForm.controls.level1.value
        }"
        [options]="level1Options"
        [placeholder]="'Common.FormControl.StatePlaceholder' | translate"
        (onChange)="level1ChangeHandler($event)"
        [showClear]="!!addressForm.controls.level1.value"
        formControlName="level1"
        (onBlur)="onTouched()"
        [required]="isRequired"
      >
      </p-dropdown>
      <div>
        <small
          class="p-error"
          *ngIf="addressForm.controls.level1.invalid && isSubmited"
        >
          {{ "Common.Validate.MustNotBeBlank" | translate }}
        </small>
      </div>
    </div>

    <div class="p-col-12 p-md-3 p-mt-2 p-mt-lg-0" *ngIf="displayLevel > 1">
      <p-dropdown
        optionLabel="name"
        optionValue="value"
        [options]="level2Options"
        [placeholder]="'Common.FormControl.CityPlaceholder' | translate"
        [ngClass]="{
          invalid:
            isRequired && isSubmited && !addressForm.controls.level2.value
        }"
        (onChange)="level2ChangeHandler($event)"
        [showClear]="!!addressForm.controls.level2.value"
        formControlName="level2"
        (onBlur)="onTouched()"
        [required]="isRequired"
        [readonly]="!addressForm.get('level1')?.value"
      >
      </p-dropdown>
      <div>
        <small
          class="p-error"
          *ngIf="addressForm.controls.level2.invalid && isSubmited"
        >
          {{ "Common.Validate.MustNotBeBlank" | translate }}
        </small>
      </div>
    </div>

    <div class="p-col-12 p-md-3 p-mt-2 p-mt-lg-0" *ngIf="displayLevel > 2">
      <p-dropdown
        optionLabel="name"
        optionValue="value"
        [options]="level3Options"
        [placeholder]="'Common.FormControl.PleaseSelect' | translate"
        (onChange)="level3ChangeHandler($event)"
        [ngClass]="{
          invalid:
            isRequired && isSubmited && !addressForm.controls.level3.value
        }"
        [showClear]="!!addressForm.controls.level3.value"
        formControlName="level3"
        (onBlur)="onTouched()"
        [required]="isRequired"
        [readonly]="!addressForm.get('level2')?.value"
      >
      </p-dropdown>
      <div>
        <small
          class="p-error"
          *ngIf="addressForm.controls.level3.invalid && isSubmited"
        >
          {{ "Common.Validate.MustNotBeBlank" | translate }}
        </small>
      </div>
    </div>

    <div class="p-col-12 p-md-3 p-mt-2 p-mt-lg-0" *ngIf="displayLevel > 3">
      <p-dropdown
        optionLabel="name"
        optionValue="value"
        [options]="level4Options"
        [placeholder]="'Common.FormControl.PleaseSelect' | translate"
        (onChange)="level4ChangeHandler($event)"
        [ngClass]="{
          invalid:
            isRequired && isSubmited && !addressForm.controls.level4.value
        }"
        [showClear]="!!addressForm.controls.level4.value"
        formControlName="level4"
        (onBlur)="onTouched()"
        [required]="isRequired"
        [readonly]="!addressForm.get('level3')?.value"
      ></p-dropdown>
      <div>
        <small
          class="p-error"
          *ngIf="addressForm.controls.level4.invalid && isSubmited"
        >
          {{ "Common.Validate.MustNotBeBlank" | translate }}
        </small>
      </div>
    </div>
  </div>

  <div class="p-grid p-mt-2">
    <div class="p-col-12 p-md-3">
      <p-dropdown
        optionLabel="name"
        optionValue="value"
        [options]="postCodeOptions"
        [placeholder]="'Common.FormControl.PostcodePlaceholder' | translate"
        (onChange)="postCodeChangeHandler($event)"
        [ngClass]="{
          invalid:
            isRequired && isSubmited && !addressForm.controls.postCode.value
        }"
        [showClear]="!!addressForm.controls.postCode.value"
        formControlName="postCode"
        (onBlur)="onTouched()"
        [required]="isRequired"
        [readonly]="!addressForm.get('level2')?.value"
      ></p-dropdown>
      <div>
        <small
          class="p-error"
          *ngIf="addressForm.controls.postCode.invalid && isSubmited"
        >
          {{ "Common.Validate.MustNotBeBlank" | translate }}
        </small>
      </div>
    </div>

    <div class="p-col-12 p-md-9">
      <div class="p-d-flex address-content-wrapper" style="flex: 1">
        <input
          class="w-100 address-content-input"
          pInputText
          type="text"
          formControlName="content"
          (change)="contentChangeHandler($event)"
          (blur)="onTouched()"
          maxlength="500"
          [ngClass]="{
            invalid:
              isRequired && isSubmited && !addressForm.controls.content.value
          }"
          [required]="isRequired"
          [placeholder]="'Common.FormControl.UnitPlaceholder' | translate"
        />
        <ng-content></ng-content>
      </div>
      <div>
        <small
          class="p-error"
          *ngIf="addressForm.controls.content.invalid && isSubmited"
        >
          {{ "Common.Validate.MustNotBeBlank" | translate }}
        </small>
      </div>
    </div>
  </div>
</form>
